




































import { Prop, Component, Vue, Mixins } from 'vue-property-decorator';
import TileComponentMixin from '@/mixins/TileComponentMixin';
import BaseNumbersTile, { IBaseNumbersTileConfiguration } from './BaseNumbersTile.vue';
import { Getter } from 'vuex-class';
import { IN2KWaterDepthEvent, N2KTemperatureEventSource, IN2KTemperatureEvent,
    N2KTemperatureEvent, N2KFluidLevelEvent } from '../../common/apis/DeviceApi';
import UserMixin from '@/mixins/UserMixin';

interface ITemperature {
    name: string;
    value: string;
    isOld: boolean;
}

@Component({
    components: {
        BaseNumbersTile,
    },
})
export default class TemperatureTile extends Mixins(TileComponentMixin, UserMixin) {

    @Prop({required: false})
    public configuration?: IBaseNumbersTileConfiguration;

    public page: number = 0;


    public get available() {
        return this.temperatures.length > 0;
    }

    public get maxPage(): number {
        return Math.floor((this.temperatures.length - 1) / 3);
    }

    public get temperatures(): ITemperature[] {
        let result: ITemperature[] = [];
        const temperatures = this.getTemperatures(this.deviceNumber);
        for (const key in temperatures) {
            if (key) {
                const temperature = temperatures[(key as any) as N2KTemperatureEventSource];
                if (temperature && temperature.temperature) {
                    result.push({
                        name: this.$t('tiles.temperature.' + key).toString(),
                        value: (Math.round(temperature.temperature * 10) / 10).toFixed(1) + '°',
                        isOld: this.getAgeInSeconds(temperature) > 180, // Older than 3 minutes
                    });
                }
            }
        }
        if (result.length === 0 && this.isDemo) {
            result = this.demoData;
        }
        return result;
    }

    public get temperaturesByPage(): ITemperature[] {
        const temperatures = this.temperatures;
        const result: ITemperature[] = [];
        for (let i = this.page * 3; i < Math.min((this.page + 1) * 3, temperatures.length); i++) {
            result.push(temperatures[i]);
        }
        return result;
    }

    @Getter('n2k/temperatures')
    private getTemperatures: (deviceNumber: string) => {[key in N2KTemperatureEventSource]?: IN2KTemperatureEvent} | null;
    private pageChangeInterval: number = 0;
    private demoData: ITemperature[] = [];
    private demoDataInterval: number;

    public mounted() {
        if (this.isDemo) {
            this.generateDemoData();
            this.demoDataInterval = setInterval(this.generateDemoData, 1000);
        }
        this.pageChangeInterval = setInterval(() => {
            this.page++;
            if (this.page > this.maxPage) {
                this.page = 0;
            }
        }, 3000);
    }

    public beforeDestroy() {
        clearInterval(this.pageChangeInterval);
        clearInterval(this.demoDataInterval);
    }


    private getAgeInSeconds(event: IN2KTemperatureEvent): number {
        if (event && event.timestamp) {
            const timestamp = typeof event.timestamp === 'object'
                ? event.timestamp
                : new Date(event.timestamp);

            return (new Date().getDate() - timestamp.getDate()) / 1000;
        }
        return 999;
    }
    private generateDemoData() {
        if (this.demoData.length === 0) {
            this.demoData.push({
                name: this.$t('tiles.temperature.Sea').toString(),
                value: '5°',
                isOld: false,
            });
            this.demoData.push({
                name: this.$t('tiles.temperature.Inside').toString(),
                value: '22,1°',
                isOld: false,
            });
            this.demoData.push({
                name: this.$t('tiles.temperature.ExhaustGas').toString(),
                value: '60,5°',
                isOld: false,
            });
        }
    }
}
